import { render } from "./MonoTrame.vue?vue&type=template&id=167dde71&scoped=true"
import script from "./MonoTrame.vue?vue&type=script&lang=js"
export * from "./MonoTrame.vue?vue&type=script&lang=js"

import "./MonoTrame.vue?vue&type=style&index=0&id=167dde71&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-167dde71"]])

export default __exports__